const TRAILING_ACTIONS = [
  "created",
  "updated",
  "deleted",
  "published",
  "archived",
  "restored",
  "disabled",
];

/**
 * Split API `time_and_user_info` into a bold subject + trailing action.
 * e.g. "Allergies & Sensitivities Need Assessment created"
 */
export function parseRevisionDescription(text) {
  if (!text || typeof text !== "string") {
    return { subject: "", action: "" };
  }

  const trimmed = text.trim();
  if (!trimmed) return { subject: "", action: "" };

  // Any "<subject> <verb>ed by <user>" — keep the verb (published / disabled /
  // updated / archived / restored …) so the timeline can colour its chip.
  const verbByMatch = trimmed.match(/^(.+?)\s+([a-z]+ed by .+)$/i);
  if (verbByMatch) {
    return {
      subject: verbByMatch[1].trim(),
      action: verbByMatch[2].trim(),
    };
  }

  const words = trimmed.split(/\s+/);
  const lastWord = words[words.length - 1]?.toLowerCase();
  if (TRAILING_ACTIONS.includes(lastWord)) {
    return {
      subject: words.slice(0, -1).join(" "),
      action: words[words.length - 1],
    };
  }

  return { subject: trimmed, action: "" };
}
